import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Divider, Typography, Stack, Button } from '@mui/material';

import NewProject from '../components/NewProject';
import AlertDialog from '../components/AlertDialog';
import LoadingButton from '@mui/lab/LoadingButton';
import Login from '../components/Login';
import Projects from '../components/Projects';

const Input = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [projects, setProjects] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [dataAlert, setDataAlert] = useState({ isShow: false, severity: '', title: '', message: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAdmin)
      getProjects();
  }, [isAdmin]);

  const getProjects = () => {
    axios.get(`https://backend-minerva-entity.pathrover.ir/api/project/GetProjects`).then(res => {
      setProjects(res.data);
    });
  }

  const addProject = () => {
    setOpenDialog(true);
  }

  const saveProject = () => {
    getProjects();
    setOpenDialog(false);
    setDataAlert({ isShow: true, severity: 'success', title: 'Success', message: 'Project added successfully.' });
  }

  const FetchInfo = () => {
    setLoading(true);
    axios.get(`https://backend-minerva-entity.pathrover.ir/api/project/FetchInformation`)
      .then(res => {
        getProjects();
        setDataAlert({ isShow: true, severity: 'success', title: 'Success', message: 'Data fetched successfully.' });
        setLoading(false);
      });
  }
  return (
    <>
      {isAdmin &&
        <>
          <Typography variant="h3" gutterBottom align='center'>
            MINERVA ENTITY ADMIN
          </Typography>
          <Typography variant="h6" gutterBottom align='center'>
            Knowing in which disease map the desired entity exists.
          </Typography>
          <Divider />
          <Stack spacing={2} direction="row" sx={{ mt: '20px' }}>
            <Button variant="contained" onClick={addProject}>Add Project</Button>
            <LoadingButton
              size="small"
              onClick={FetchInfo}
              loading={loading}
              variant="contained">
              <span>Fetch data</span>
            </LoadingButton>
          </Stack>
          <Projects projects={projects} isAdmin={isAdmin} onSubmit={getProjects}/>
        </>
      }
      <NewProject isOpen={openDialog} onClose={e => setOpenDialog(false)} onSubmit={saveProject} />
      <AlertDialog data={dataAlert} onClose={e => setDataAlert({ isShow: false })} />
      <Login isShow={!isAdmin} onSubmit={e => setIsAdmin(true)} />
    </>
  );
};

export default Input;